import React, { useState } from 'react'
import SearchFilter from './search-filter'
import useLearningResourcesFilters from '../../../hooks/use-learning-resources-filters'
import useDebouncedCallback from '../../../hooks/use-debounced-callback'

const NameFilter = ({
    value = '',
    disabled
}) => {
    const { setName } = useLearningResourcesFilters()
    const [ search, setSearch ] = useState(value)

    useDebouncedCallback({
        value: search,
        callback: setName
    })

    return (
        <SearchFilter
            title='What are you looking for?'
            value={search || ''}
            onChange={setSearch}
            disabled={disabled}
        />
    )
}

export default NameFilter